import React from 'react';
import {Link} from "react-router-dom";

const Partners = ({saleType}) => {
  return (
    <div>
      {(saleType === '3d' || saleType === 'all') && (
        <>
        <Link className="block p-8 link text-xl" to={`https://subscribestar.adult/appallington-adult-comics`}>&#128520; Appallington 3D Comics on SubscribeStar</Link>
        <Link className="block p-8 link text-xl" to={`https://powershopz.com/Appallington`}>&#128520; Appallington 3D Comics on Powershopz</Link>
        </>
      )}
      {(saleType === 'ai' || saleType === 'all') && (
        <Link className="block p-8 link text-xl" to={`https://powershopz.com/Appallington`}>&#128520; Appallington AI Bondage on Powershopz</Link>
      )}
  </div>
  );
}

export default Partners;
